import React from 'react';
import { Modal, Button } from 'antd';

interface CancelConfirmationModalProps {
  isVisible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({ 
  isVisible, 
  onConfirm, 
  onCancel 
}) => {
  return (
    <Modal
      title=""
      centered={true}
      open={isVisible}
      onCancel={onCancel}
      footer={[
        <Button key="back" data-testid="cancel-reject-btn" onClick={onCancel}>
          No
        </Button>,
        <Button
          key="submit"
          data-testid="cancel-confirm-btn"
          type="primary"
          danger
          onClick={onConfirm}
        >
          Yes
        </Button>,
      ]}
    >
      <p>Are you sure you want to cancel this booking?</p>
    </Modal>
  );
};

export default CancelConfirmationModal;